import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCol,
  IonGrid,
  IonItem,
  IonItemDivider,
  IonRow,
  IonText,
  IonTitle
} from '@ionic/react';
import React from 'react';

const PleaseLoginCard: React.FC<{ portal?: string, action: string }> = ({ action, portal = '' }) => {
  // Forward the current page as a redirect target so Login can send the user
  // back here after authenticating. Login reads the target from `?=<url>`
  // (see Login.tsx: search.slice(2) + decodeURI), so we encode to match.
  const loginHref = portal ? `/login?=${encodeURI(portal)}` : '/login';
  return (
    <IonGrid>
      <IonRow>
        <IonCol sizeMd='6' pushMd='3' sizeLg='4' pushLg='4'>
          <IonCard>
            <IonCardHeader color='secondary'>
              <IonItem lines='none' color='clear'>
                <IonTitle color='medium' size='large'>
                  Not Authenticated
                </IonTitle>
              </IonItem>
            </IonCardHeader>
            <IonCardContent style={{ textAlign: 'center', alignItems: 'center' }}>
              <IonItemDivider color='clear' />
              <IonRow className='ion-align-items-center'>
                <IonText>Please</IonText>
                <IonButton routerLink={loginHref} className='ion-margin-horizontal'>
                  Login
                </IonButton>
                {action && (
                  <IonText>To {action}</IonText>
                )}
              </IonRow>
            </IonCardContent>
          </IonCard>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
}
export default PleaseLoginCard;
